module.exports = "https://s.pinimg.com/webapp/style/images/PL@2x-21be8fc4.png";